import React from 'react';
import CreateExercisePlan from '../components/exercise/createExercisePlan';
import { Header } from '../components/global/header';
import { Footer } from '../components/global/footer';

const ExercisePlanPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <CreateExercisePlan />
      <Footer />
    </div>
  );
};

export default ExercisePlanPage;
